// extracted by mini-css-extract-plugin
export var clips = "index-module--clips--lmpU1";
export var clipsContainer = "index-module--clips-container--9aWXr";
export var clip1 = "index-module--clip-1--XjUW5";
export var clip2 = "index-module--clip-2--GKmGu";
export var clip3 = "index-module--clip-3--tlRs-";
export var clip4 = "index-module--clip-4--+SQSx";